<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()">
    <v-card>
      <!-- <v-card-title>{{ dialogTitle }}</v-card-title> -->
      <!-- <v-card-text>
        <div class="text-center py-10">
          <h3>{{ dialogTitle }}</h3>
          <p class="my-3">{{ "lng_box_detail_txt" | translate }}</p>
        </div>
      </v-card-text> -->
      <v-card-text v-if="dealerData" class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-10">
          <h3>{{ dialogTitle }}</h3>
        </div>
        <v-row class="ma-0 pb-3">
          <strong class="pr-3">{{ "lng_th_user_type_txt" | translate }}:</strong>
          <userRoles :roleKey="dealerData.authlevel" />
        </v-row>
        <p>
          <strong>{{ "lng_th_email_txt" | translate }}:</strong>
          {{dealerData.email}}
        </p>
        <p>
          <strong>{{ "lng_invoice_email_text" | translate }}:</strong>
          {{dealerData.invoiceemail}}
        </p>
        <p>
          <strong>{{ "lng_th_name_txt" | translate }}:</strong>
          {{dealerData.name}}
        </p>
        <p>
          <strong>{{ "lng_th_companyName_txt" | translate }}:</strong>
          {{dealerData.companyname}}
        </p>
        <p>
          <strong>{{ "lng_th_cvr_txt" | translate }}:</strong>
          {{dealerData.cvr}}
        </p>
        <p>
          <strong>{{ "lng_th_address_txt" | translate }}:</strong>
          {{dealerData | formatAddress}}
        </p>
        
        <p style="text-align: center;">
          <v-btn class="link-button" small color="primary" dark @click="goToSystem">
            {{ "lng_login_as_txt" | translate }} {{ getTextBasedOnRoles(dealerData) }}</v-btn></p>

      </v-card-text>

      <v-card-text v-else class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-10">
          <h3>{{ dialogTitle }}</h3>
          <v-progress-circular
            color="#0b7894"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-card-text>  
  
    <!-- System info -->
    
        <div style="overflow-x: auto;" v-for="(systemsData, index) in systemData" :key="index" class="content-modl ml-5 mr-5">
          <table class="table table-bordered table-striped" v-if="systemData && systemsData.system.id === dealerData.systemid" >
            <thead >
              <tr>
                <th>#</th>
                <th scope="col">{{ "lng_th_systemId" | translate }}</th>
                <th scope="col">{{ "lng_th_address" | translate }}</th>
                <th scope="col">{{ "lng_th_alarm_email" | translate }}</th>
                <th scope="col">{{ "lng_th_alarm_phone" | translate }}</th>
                <th scope="col">{{ "lng_th_mac_number_txt" | translate }}</th>
                <th scope="col" v-if="systemsData.system.rssi">{{ "lng_th_rssi" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-toggle="collapse" :data-target="`#collapsedRow${systemsData.system.id}`" class="accordion-toggle collapsed expand-button"></td>
                <th scope="row">{{ systemsData.system.id }}</th>
                <td>
                  {{systemsData.system | formatAddress}}
                </td>
                <td>{{ systemsData.system.alarmemail }}</td>
                <td>{{ systemsData.system.alarmsms }}</td>
                <td>{{ systemsData.system.mecnumber }}</td>

                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <td v-bind="attrs" v-on="on" v-if="systemsData.system.rssi >= 1 && systemsData.system.rssi < 5 ">
                      <v-icon color="red">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 5  && systemsData.system.rssi < 7">
                      <v-icon color="orange">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 7  && systemsData.system.rssi <= 9">
                      <v-icon color="yellow">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 10  && systemsData.system.rssi <= 12">
                      <v-icon color="blue">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 13  && systemsData.system.rssi < 20">
                      <v-icon color="purple">mdi-antenna</v-icon>
                    </td>
                    <td v-bind="attrs" v-on="on" v-else-if="systemsData.system.rssi >= 20">
                      <v-icon color="green">mdi-antenna</v-icon>
                    </td>
                  </template>
                   <span>{{"lng_th_rssi" | translate}}:{{systemsData.system.rssi}}</span><br>
                    <span>{{"lng_th_rssi_date" | translate}}:{{systemsData.system.rssidate}}</span>
                </v-tooltip>
                 <tr>
                  <td colspan="12" class="hiddenRow">
                    <div class="accordion-body collapse container-fluid" :id="`collapsedRow${systemsData.system.id}`">
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th>{{ "lng_th_boxType" | translate }}</th>
                            <th>{{ "lng_th_boxId" | translate }}</th>
                            <th>{{ "lng_th_boxPass" | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ "lng_sewer_text" | translate }}</td>
                            <td>{{ systemsData.devices[0].id }}</td>
                            <td>{{ systemsData.devices[0].pincode }}</td>
                          </tr>
                          <tr>
                            <td>{{ "lng_house_text" | translate }}</td>
                            <td>{{ systemsData.devices[1].id }}</td>
                            <td>{{ systemsData.devices[1].pincode }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
              </tr>
            </tbody>
          </table>
       </div>

    <!-- System info -->
    </v-card>
  </v-dialog>
</template>

<script>
import { countries, sewerTypeValues } from "../../common/Constant";
import GlobalService from "../../services/global-service";
import router from "../../router";
import { translateFunc } from '../../common/Filters';
import { getTextBasedOnRoles } from "../../common/HelperFunctions"
import UserRoles from "./UserRoles.vue";

export default {
  name: "DealerInfoModal",
  components: {
    UserRoles
  },
  data() {
    return {
      dialog: false,
      usersData: undefined,
      dealerTokenResponse: undefined,
      authLevel:undefined,

    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    dealerData: {
      type: Object,
      default: () => {}
    },
    adminToken: {
      type: String,
      default: ""
    },
    systemData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
      if(newVal){
        this.usersData = undefined;
        this.getDealerTokenFromAdmin(this.adminToken);
      }
    }
  },
  mounted() {
    this.authLevel = sessionStorage.authLevel;    
  },
  methods: {
    getTextBasedOnRoles,
    async getDealerTokenFromAdmin(token) {
      this.dealerTokenResponse = await GlobalService.getDealerToken(token, this.dealerData.id);
      if (this.dealerTokenResponse.token ) {
        // await this.fetchUserInfo(this.dealerTokenResponse.token)
      }
    },
    async fetchUserInfo(token) {
      this.usersData = await GlobalService.getUserInfo(token);
    },
    goToSystem(){
      if (this.dealerTokenResponse.token ) {
        let routeData = `/login?token=${this.dealerTokenResponse.token}&authLevel=${this.dealerData.authlevel}`;
        window.open(routeData, '_blank');
      }
    }
  }
};
</script>
<style scoped>
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 95%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 99991 !important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 99992 !important;
}
</style>
